module.exports = __webpack_public_path__ + "static/media/filtros.3ed8ea72.svg";